import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

interface LoadingOverlayProps {
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  message = "Completing sign-in..."
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="fixed inset-0 z-[100] flex items-center justify-center backdrop-blur-md"
      style={{
        backgroundColor: 'rgba(10, 10, 10, 0.9)'
      }}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.1 }}
        className="flex flex-col items-center gap-4 p-8 rounded-2xl border"
        style={{
          backgroundColor: 'rgba(20, 20, 20, 0.8)',
          borderColor: 'var(--border-color)'
        }}
      >
        {/* Spinning loader icon */}
        <motion.div
          animate={{ rotate: 360 }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: "linear"
          }}
          className="text-soundwave-500"
        >
          <Loader2 className="w-10 h-10" />
        </motion.div>

        {/* Loading message */}
        <div className="flex flex-col items-center gap-2">
          <p
            className="text-lg font-semibold"
            style={{ color: 'var(--text-primary)' }}
          >
            {message}
          </p>
          <p
            className="text-sm"
            style={{ color: 'var(--text-secondary)' }}
          >
            This will only take a moment
          </p>
        </div>

        {/* Animated dots */}
        <div className="flex gap-1.5">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-2 h-2 rounded-full bg-soundwave-500"
              animate={{
                opacity: [0.3, 1, 0.3],
                scale: [0.8, 1, 0.8]
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: i * 0.2
              }}
            />
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default LoadingOverlay;
